import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=1049bed0&scoped=true&"
import script from "./Meta.vue?vue&type=script&lang=js&"
export * from "./Meta.vue?vue&type=script&lang=js&"
import style0 from "./Meta.vue?vue&type=style&index=0&id=1049bed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049bed0",
  null
  
)

export default component.exports